import MyTeamCreatedLead from "./myTeamCreatedLead";

export default MyTeamCreatedLead;
